export * from './card.module';
export * from './card.component';



// WEBPACK FOOTER //
// ./src/app/layout/card/index.ts